import { render, staticRenderFns } from "./BorderlessCard.vue?vue&type=template&id=1ec8f168&scoped=true&"
import script from "./BorderlessCard.vue?vue&type=script&lang=ts&"
export * from "./BorderlessCard.vue?vue&type=script&lang=ts&"
import style0 from "./BorderlessCard.vue?vue&type=style&index=0&id=1ec8f168&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec8f168",
  null
  
)

export default component.exports